/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { footerStyle } from "./styles";
import footerBottomTextImg from "../../assets/footer-text.png";
import * as _ from "lodash";
import { responsiveStyles } from "../../commons/styles";
import {
  joinUsNowText,
  buttonActions,
  partnerEmailAddress,
  tcLabel,
  GAEvents,
} from "../../constants/commons";

import { useIsMobile, useIsTab } from "../../hooks/useIsMobile";
import { IFooterProps } from "./types";
import { useUserContext } from "../../hooks/cookieHooks";
import { GA_Event } from "../../utils/reactGA";

export const Footer: React.FC<IFooterProps> = (props: IFooterProps) => {
  const {
    heading,
    footerContactDetails,
    onButtonClickAction,
    className,
  } = props;
  const isMobile = useIsMobile();
  const isTabView = useIsTab();
  const user = useUserContext();

  const footerDetails =
    footerContactDetails &&
    footerContactDetails.map((data, key: number) => {
      let hrefData: string;
      if (data.mailTo) {
        hrefData = `mailto:${partnerEmailAddress}?subject=${""}&body=${""}`;
      } else {
        hrefData = data.link;
      }
      return (
        <div
          className={`${
            _.isEmpty(user) && data.name === tcLabel
              ? "d-none"
              : "d-flex flex-column"
          }`}
          key={key}
        >
          <a
            className="footer-details-color m-0 user-button-style mb-3"
            key={key}
            target="_blank"
            rel="noopener noreferrer"
            href={hrefData}
            onClick={() => triggerGA(data.name)}
          >
            {data.name}
          </a>
        </div>
      );
    });

  const triggerGA = (tag: string) => {
    if (tag === GAEvents.CONTACT_US || tag === GAEvents.PRIVACY_POLICY) {
      GA_Event(tag, "clicked");
    }
  };

  const onButtonClick = (type: string) => {
    GA_Event(GAEvents.JOIN_US_NOW, "clicked", "from footer");
    onButtonClickAction && onButtonClickAction(type);
  };

  return (
    <span
      className={`footer-container-padding row no-gutters
      ${className ? className : ""}`}
      css={[footerStyle(!_.isEmpty(user)), responsiveStyles]}
    >
      <div
        className={` ${
          isMobile || isTabView
            ? " responsive-top-container-footer"
            : "responsive-top-container-footer d-flex w-100 align-items-center justify-content-center"
        }`}
      >
        <div
          className={`${
            isMobile
              ? "col-sm-8 d-flex align-items-center my-3"
              : "col-md-8 d-flex align-items-center p-0 responsive-tab-margin"
          }`}
        >
          <h1 className="font-bold">
            {_.isEmpty(user) ? (
              _.find(heading)
            ) : (
              <img
                src={footerBottomTextImg}
                alt=""
                width={isMobile || isTabView ? "85%" : "65%"}
              />
            )}
          </h1>
        </div>

        <div className={`col-md-4 ${isMobile ? "" : "text-right p-0"}`}>
          <div
            className={`col-md-12 responsive-font-body p-0 d-flex ${
              isMobile
                ? "row no-gutters d-flex align-items-center"
                : "align-items-center"
            }`}
          >
            <div
              className={`col-9 col-sm-4 col-md-12 ${
                isTabView ? "text-left" : ""
              }`}
            >
              {footerDetails}
            </div>

            {/* <div
              className={`col-3 col-sm-8 d-md-none d-xs-block d-flex  justify-content-center flex-column ${
                isTabView ? "align-items-end" : "align-items-center"
              }`}
            >
              {details}
            </div> */}
          </div>
          {/* {!_.isEmpty(user) && (
            <div className="d-none d-md-flex ml-auto">{details}</div>
          )} */}
        </div>
      </div>
      <div className="d-flex w-100 mr-auto">
        <div className={_.isEmpty(user) ? "col-12 col-md-8 p-0" : "d-none"}>
          <button
            className="button-style-red col-sm-12 col-md-4 text-white user-button-style"
            onClick={() => onButtonClick(buttonActions.SIGNUP)}
          >
            {joinUsNowText}
          </button>
        </div>
        {/* {_.isEmpty(user) && (
          <div className="d-none d-md-flex ml-auto">{details}</div>
        )} */}
      </div>

      <div
        className={
          _.isEmpty(user)
            ? "col-md-8 col-sm-12 responsive-margin-footer"
            : "d-none"
        }
      >
        <img
          src={footerBottomTextImg}
          alt=""
          width={isMobile || isTabView ? "85%" : "65%"}
        />
      </div>
    </span>
  );
};
